class Logger {
  constructor() {
    this.isDevelopment = import.meta.env.DEV;
    this.isProduction = import.meta.env.PROD;
  }

  // Método principal de logging
  log(level, message, data = null) {
    const timestamp = new Date().toISOString();
    const logEntry = {
      timestamp,
      level: level.toUpperCase(),
      message,
      data
    };

    // En desarrollo: mostrar en consola con colores
    if (this.isDevelopment) {
      const color = this.getColor(level);
      console.log(
        `%c[${timestamp}] ${level.toUpperCase()}: ${message}`,
        `color: ${color}; font-weight: bold;`,
        data || ''
      );
    }

    // En producción: solo errores críticos
    if (this.isProduction && (level === 'error' || level === 'critical')) {
      console.error(`[${timestamp}] ${level.toUpperCase()}: ${message}`, data);
    }

    // Aquí se puede agregar envío a servicio de logging externo
    this.sendToExternalService(logEntry);
  }

  // Métodos de conveniencia
  info(message, data) {
    this.log('info', message, data);
  }

  success(message, data) {
    this.log('success', message, data);
  }

  warning(message, data) {
    this.log('warning', message, data);
  }

  error(message, data) {
    this.log('error', message, data);
  }

  debug(message, data) {
    if (this.isDevelopment) {
      this.log('debug', message, data);
    }
  }

  // Colores para desarrollo
  getColor(level) {
    const colors = {
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FF9800',
      error: '#F44336',
      debug: '#9C27B0'
    };
    return colors[level] || '#000000';
  }

  // Placeholder para servicio externo
  sendToExternalService(logEntry) {
    // En el futuro se puede integrar con Sentry, LogRocket, etc.
    if (this.isProduction && logEntry.level === 'ERROR') {
      // Enviar errores críticos a servicio externo
    }
  }
}

// Exportar instancia singleton
export const logger = new Logger();